import React, {useState, useEffect} from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';
import './css/List.css'
import IconArrowRight from "../../assets/icons/icon-arrow-right.png"
import IconArrowLeft from "../../assets/icons/icon-arrow-left.png"
import IconDeleteConfirmation from "../../assets/icons/icon-delete-confirmation.png"
import '../../components/Website/Website.css'
import {
    deleteAdminUser,
    getAdminUsersList
  } from '../../services/requests'
import Layout from '../../components/Website/Layout'
import { getToken } from '../../services/token';
import IconActions from "../../assets/icons/icon-actions.png"
import IconDelete from "../../assets/icons/icon-delete.png"
import IconEdit from "../../assets/icons/icon-edit.png"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const AdminUsersList = () => {

    const [userId, setUserId] = useState();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const [isLoading, setLoading] = useState(false);
    const [users, setUsers] = useState(null);
    const [pageTotal, setPageTotal] = useState(0)

    const loadData = async (keywordSupplied) => {
        if (!isLoading) {
          setLoading(true);
          var localPage = 1
          if (searchParams.get('page')) {
            localPage = searchParams.get('page')
          }

          const resp = await getAdminUsersList(localPage, keywordSupplied);

          setUsers(resp?.users?.data);
          setPageTotal(resp?.users?.last_page)
          setLoading(false);
        }
      };
      useEffect(() => {
        if (!getToken()) { navigate("/") }

        loadData('');
        document.title = 'Eason Loyal App - Users';
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    function handleUpdatePage(page) {
      if (isNaN(page)) { 
        page = 2
      }
      searchParams.set('page', page)
      loadData('')
    }
          
    const handleEditClick = (userId) => {
      navigate(`/admin/admin-users/${userId}`);
    };    

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const handleCloseDeleteConfirmation = () => setShowDeleteConfirmation(false);
    const handleShowDeleteConfirmation = () => setShowDeleteConfirmation(true);

    function handleDelete(id) {
      handleCloseDeleteConfirmation()
      deleteAdminUser(id).then((results) => {        
        searchParams.set('page', 1)
        searchParams.set('deleted', 'true')
        loadData('');
      })
    }

    function handleConfirmDelete(id) {
      setUserId(id)
      handleShowDeleteConfirmation()
    }

    const [state, setState] = useState([])
    var toggleOpen = (index) => {
      var stateLocal = state;
      if (stateLocal[index] === "true") {
        stateLocal[index] = "false"
        loadData()
      }
      else {
        stateLocal = [];
        stateLocal[index] = "true"
      }
      setState( stateLocal );
    }
    var closeAll = (e) => {
      if (e.target.id === "dropdownMenuButton") {
        return
      }
      setState([]);
    }

    return <>
      <Layout>
        <div className="container">
            
        {searchParams.get('updated') ? (
        <div className={'alert alert-success'}>The user has now been saved.</div>
        ) : null}                
        {searchParams.get('deleted') ? (
        <div className={'alert alert-success'}>The user has now been deleted.</div>
        ) : null}                

        <div className="form-group">
            <div className="users_add-wrapper">
                <div className="form-group" style={{ marginBottom: '20px' }}>
                  <Button
                      variant="primary"
                      onClick={() => navigate('/admin/admin-users/new')}
                      style={{ minWidth: 180 }}
                  >
                      + Add Admin User
                  </Button>
              </div>
            </div>  
        </div>

        <Modal show={showDeleteConfirmation} onHide={handleCloseDeleteConfirmation}
                aria-labelledby="contained-modal-title-vcenter" centered
              >
              <Modal.Header className="px-4" closeButton>
                <Modal.Title className="ms-auto">
                  <img src={IconDeleteConfirmation} style={{width: '50px', height: '50px'}} alt=""/>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body  style={{
                display: "flex",
                justifyContent: "center",
                }}>Are you sure you want to delete this admin user?</Modal.Body>
              <Modal.Footer style={{
                display: "flex",
                justifyContent: "center",
                }} className="px-4">
                <Button centered variant="secondary" style={{width: '100px'}} onClick={handleCloseDeleteConfirmation}>
                  No
                </Button>
                <Button centered variant="primary" style={{width: '100px'}} onClick={() => handleDelete(userId)}>
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>

            <h3 className="website__header">Admin Users</h3>
            
            <div className="offers__table-box">
            <table className="offers__table" onClick={(e) => closeAll(e)}>
              <thead>
                <tr>
                <th style={{borderTopLeftRadius: '16px'}}>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th style={{borderTopRightRadius: '16px'}}>Action</th>
                </tr>
              </thead>
              <tbody>

            {users?.map((user, index) => {

                var menuClass = `dropdown-menu${state[index]==="true" ? " show" : ""}`;
                return (
                    <tr key={user?.id}>
                      <td>
                        {user?.first_name}
                      </td>
                      <td>
                        {user?.last_name}
                      </td>
                      <td>
                        {user?.email}
                      </td>
                      <td style={{width: '100px'}}>
                        <img src={IconActions} style={{width: '20px', height: '20px'}} 
                          onClick={() => toggleOpen(index)}
                          className="dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          alt=""
                        />

                        <div className={menuClass} aria-labelledby="dropdownMenuButton" style={{width: '125px'}}>
                          <button onClick={() => handleEditClick(user?.id)} className="dropdown-item" style={{ fontSize: '13px' }}>
                            <img src={IconEdit} className="offers__delete-icon" alt=""/> Edit
                          </button>
                          <button onClick={() => handleConfirmDelete(user?.id)} className="dropdown-item" style={{ fontSize: '13px' }}>
                            <img src={IconDelete} className="offers__delete-icon" alt=""/> Delete
                          </button>
                        </div>

                      </td>

                    </tr>                    
                );
            })}
            </tbody>
            </table>

            <div style={{backgroundColor: '#fff', width: '100%', height: '30px', 
                    marginTop: '15px',
                    marginBottom: '15px'}}>
                <div style={{float: 'right'}}>

{(!searchParams.get('page') || parseInt(searchParams.get('page')) === 1) ? 
<><div className="pageLink disabled">
  <img src={IconArrowLeft} style={{width: '14px', height: '14px'}} alt="left" />
</div></>
: 
<><div className="pageLink" onClick={() => handleUpdatePage(parseInt(searchParams.get('page')) - 1)}>
  <img src={IconArrowLeft} style={{width: '14px', height: '14px'}} alt="left" />
</div></>}

{[...Array(pageTotal)].map((x, i) => {
  const currentPage = parseInt(searchParams.get('page')) || 1;
  const page = i + 1;
  const isCurrentPage = page === currentPage;
  const isNearCurrentPage = Math.abs(page - currentPage) <= 2;
  const isNearStart = page <= 3;
  const isNearEnd = pageTotal - page < 3;

  if (isNearStart || isNearEnd || isNearCurrentPage) {
    return (
      <div
        key={page}
        onClick={() => handleUpdatePage(page)}
        className={"pageLink" + (isCurrentPage ? ' active' : '')}
      >
        {page}
      </div>
    );
  } else if (page === 4 && currentPage > 5) {
    return <div key={page} className="pageLink">...</div>;
  } else if (page === pageTotal - 3 && currentPage < pageTotal - 4) {
    return <div key={page} className="pageLink">...</div>;
  } else {
    return null;
  }
})}

{(pageTotal === 1 || parseInt(searchParams.get('page')) === pageTotal) ? 
<><div className="pageLink disabled">
  <img src={IconArrowRight} style={{width: '14px', height: '14px'}} alt="right" />
</div></>
: 
<><div className="pageLink" onClick={() => handleUpdatePage(parseInt(searchParams.get('page')) + 1)}>
  <img src={IconArrowRight} style={{width: '14px', height: '14px'}} alt="right" />
</div></>}

                </div>                  
              </div>
            </div>

        </div>
      </Layout>
    </>
}

export default AdminUsersList;
